var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwIconB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_646_70)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0886 25.6709C19.9886 25.6709 25.5823 20.0773 25.5823 13.1772C25.5823 6.27717 19.9886 0.683559 13.0886 0.683559C6.18852 0.683559 0.59491 6.27717 0.59491 13.1772C0.59491 20.0773 6.18852 25.6709 13.0886 25.6709Z",
    stroke: "#0C4B76",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1611 10.1108C18.6906 9.77665 19.0968 9.24685 19.2875 8.61573C18.7918 8.92588 18.244 9.15017 17.6595 9.2716C17.1931 8.74567 16.5265 8.41774 15.7888 8.41774C14.3735 8.41774 13.2266 9.62815 13.2266 11.1209C13.2266 11.3328 13.2478 11.5393 13.2918 11.7365C11.1622 11.6236 9.27393 10.5485 8.00895 8.91196C7.78821 9.31259 7.66208 9.77665 7.66208 10.2716C7.66208 11.209 8.11454 12.0366 8.8024 12.5223C8.38221 12.5084 7.98695 12.3854 7.64082 12.1843V12.2176C7.64082 13.5278 8.52374 14.6206 9.69779 14.8681C9.4822 14.9315 9.25633 14.9632 9.02167 14.9632C8.85667 14.9632 8.69534 14.947 8.53987 14.9153C8.86547 15.9888 9.81219 16.7715 10.9342 16.7924C10.0564 17.5179 8.95127 17.9494 7.75081 17.9494C7.54402 17.9494 7.33942 17.9378 7.13922 17.9123C8.27368 18.6788 9.6208 19.1266 11.0684 19.1266C15.7837 19.1266 18.3606 15.0073 18.3606 11.4349C18.3606 11.3173 18.3591 11.2005 18.354 11.0853C18.8548 10.704 19.2904 10.2276 19.6329 9.68538C19.1731 9.90039 18.6788 10.0458 18.1611 10.1108Z",
    fill: "#0C4B76"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_646_70"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.1772,
    height: 26.1772,
    fill: "white",
    transform: "translate(0 0.088623)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwIconB);
export default __webpack_public_path__ + "static/media/tw-icon-b.93b59455f91eed7d862a854e35ad5853.svg";
export { ForwardRef as ReactComponent };